import { render, staticRenderFns } from "./user-charge-editor.vue?vue&type=template&id=174828e8&scoped=true&"
import script from "./user-charge-editor.vue?vue&type=script&lang=ts&"
export * from "./user-charge-editor.vue?vue&type=script&lang=ts&"
import style0 from "./user-charge-editor.vue?vue&type=style&index=0&id=174828e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174828e8",
  null
  
)

export default component.exports